import { useCallback, useEffect, useRef, useState } from 'react';

import { useAtom } from 'jotai';
import { useMutationObserver } from 'ui/Hooks';

import { headerBackButtonContainerRefAtom } from './navigation.atoms';

const observerOptions = {
  childList: true,
};

const useManageBackButton = () => {
  const headerRef = useRef<HTMLDivElement | null>(null);

  const [isLogoHidden, setIsLogoHidden] = useState(false);

  const [headerLogoContainerElement, setHeaderBackButtonContainer] = useAtom(
    headerBackButtonContainerRefAtom
  );

  const callBack = useCallback((mutationList: MutationRecord[]) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        const targetNodeList = Array.from(mutation.target.childNodes);

        const targetHasBackButton = targetNodeList.find((node) => {
          return (node as HTMLElement).id === 'header-back-button';
        });
        if (targetHasBackButton) {
          setIsLogoHidden(true);
        }

        if (!targetHasBackButton) {
          setIsLogoHidden(false);
        }
      }
    }
  }, []);

  useMutationObserver(
    callBack,
    observerOptions,
    () => document.getElementById('header-back-button-container')!
  );

  useEffect(() => {
    if (headerRef !== undefined) {
      setHeaderBackButtonContainer(headerRef);
    }

    return () => {
      if (headerRef) {
        setHeaderBackButtonContainer(null);
      }
    };
  }, [headerLogoContainerElement, headerRef, setHeaderBackButtonContainer]);

  return {
    ref: headerRef,
    isLogoHidden,
  };
};

export { useManageBackButton };
